import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectDealType } from '../../../selectors/page';
import { EDealType } from '../../../types/dealType';

export const useAddOfferTitle = () => {
  const dealType = useSelector(selectDealType);

  return React.useMemo(() => {
    return `${dealType === EDealType.Sale ? 'Продайте' : 'Сдайте'} квартиру сами`;
  }, [dealType]);
};
